import { GetNotesByAsset } from "../../../../common/components/notes/hooks/state/NoteSource";
import { useGetNotesByAssets } from "../../../../common/data/data-hooks/useGetNotesByAssets";
import { AssetType } from "../../../../common/types/AssetType";
import { DraftAssetType } from "../../../../common/types/DraftAssetType";
import { OrderAssetAvailability } from "../../../common/types/OrderAssetAvailability";
import { OnPremOrderDashboardItem } from "../OnPremOrderDashboardItem";

const prepareAssets = ({ onPremOrder }: { onPremOrder?: OnPremOrderDashboardItem }): GetNotesByAsset[] => {
    const assets: GetNotesByAsset[] = [];

    if (!onPremOrder) {
        return [];
    }

    if (onPremOrder.onPremAssets.video.assetId) {
        assets.push(
            getNotesByAssetParams({
                id: onPremOrder.onPremAssets.video.assetId,
                availability: onPremOrder.onPremAssets.video.availability
            })
        );
    }

    if (onPremOrder.onPremAssets.soundtracks.length) {
        onPremOrder.onPremAssets.soundtracks.forEach((soundtrack) => {
            if (soundtrack.assetId) {
                assets.push(
                    getNotesByAssetParams({
                        id: soundtrack.assetId,
                        availability: soundtrack.availability
                    })
                );
            }
        });
    }

    if (onPremOrder.onPremAssets.subtitles.length) {
        onPremOrder.onPremAssets.subtitles.forEach((subtitle) => {
            if (subtitle.assetId) {
                assets.push(
                    getNotesByAssetParams({
                        id: subtitle.assetId,
                        availability: subtitle.availability
                    })
                );
            }
        });
    }

    return assets;
};

export const useOnPremOrderAssetNotes = ({ onPremOrder }: { onPremOrder?: OnPremOrderDashboardItem }) => {
    const assets = prepareAssets({ onPremOrder });
    const { data: notes, isLoading } = useGetNotesByAssets({ assets });

    return { notes, areNotesLoading: isLoading };
};

const getNotesByAssetParams = ({
    id,
    availability
}: {
    id: string;
    availability: OrderAssetAvailability;
}): GetNotesByAsset => ({
    id,
    assetType: availability === OrderAssetAvailability.FullMatch ? AssetType.OnPrem : undefined,
    draftAssetType: availability === OrderAssetAvailability.PartialMatch ? DraftAssetType.OnPrem : undefined
});
